import {
    ChangeDetectorRef,
    Component,
    Input,
    OnChanges,
    OnDestroy,
    SimpleChanges,
} from "@angular/core";
import { Subscription, finalize } from "rxjs";

import { v4 } from "uuid";

import { Product, SizeGuide } from "@hermes/api-model-product";

import {
    ProductType,
    shouldDisplaySizeGuideButton,
} from "@hermes/product-size-guide";

import { TrayFacade } from "@hermes/states/tray";

import { SizeGuideService } from "../../services/size-guide.service";
type AlignUnionClass = "align-center" | "align-right";
@Component({
    selector: "h-call-to-action-size-guide",
    templateUrl: "./call-to-action-size-guide.component.html",
    styleUrls: ["./call-to-action-size-guide.component.scss"],
})
export class CallToActionSizeGuideComponent implements OnDestroy, OnChanges {
    @Input({ required: true })
    public product!: ProductType;

    @Input()
    public itemSku: string = "";

    @Input()
    public withPaddingBottom: boolean = false;

    @Input()
    public hasMargin: boolean = true;

    @Input()
    public buttonAlignClass: AlignUnionClass = "align-center";

    @Input()
    public isNewMeasureIconEnabled: boolean = false;

    public isSizeGuideButtonVisible: boolean = false;
    public isLoading: boolean = false;
    public hasErrorLoadingSizeGuide: boolean = false;
    private subscription: Subscription = new Subscription();

    constructor(
        private changeDetectorRef: ChangeDetectorRef,
        private sizeGuideService: SizeGuideService,
        private trayFacade: TrayFacade,
    ) {}

    private get sizeGuideId(): string | undefined {
        return this.product instanceof Product
            ? this.product?.content?.sizeGuideId
            : this.product?.sizeGuideId;
    }

    public ngOnChanges({ product, itemSku }: SimpleChanges): void {
        if (product || itemSku) {
            this.isSizeGuideButtonVisible = shouldDisplaySizeGuideButton(
                this.product,
            );
            this.hasErrorLoadingSizeGuide = false;
        }
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    public openSizeGuideTray(): void {
        this.isLoading = true;
        this.hasErrorLoadingSizeGuide = false;
        if (this.sizeGuideId) {
            this.subscription.add(
                this.sizeGuideService
                    .getSizeGuide(this.sizeGuideId)
                    .pipe(
                        finalize(() => {
                            this.isLoading = false;
                            this.changeDetectorRef.detectChanges();
                        }),
                    )
                    .subscribe({
                        next: (content: SizeGuide) => {
                            this.openTrayWithContent(content);
                        },
                        error: () => {
                            this.hasErrorLoadingSizeGuide = true;
                            this.changeDetectorRef.detectChanges();
                        },
                    }),
            );
        } else {
            this.isLoading = false;
            this.hasErrorLoadingSizeGuide = true;
            this.changeDetectorRef.detectChanges();
        }
    }

    private openTrayWithContent(sizeGuide: SizeGuide): void {
        this.trayFacade.openTray({
            hasOverlay: true,
            hasCategoryInstitutional: false,
            isOpen: true,
            position: "right",
            titleKey: "hermes_commerce.size-guide",
            uuid: v4(),
            name: "size-guide-tray",
            metadata: {
                content: sizeGuide,
                sku: this.itemSku,
            },
        });
    }
}
